import { type UUID } from '~/types/common';

import { type DataExchangeExcelDataType } from './useQueryDataExchangeExcelData';

export const queryKeysDataExchange = {
  base: () => 'dataExchange' as const,
  get: (dataExchangeId: UUID) =>
    [queryKeysDataExchange.base(), 'detail', dataExchangeId] as const,
  getAllEligiblePeople: (dataExchangeId: UUID | undefined) =>
    [
      queryKeysDataExchange.base(),
      'eligiblePeople',
      { dataExchangeId },
    ] as const,
  getAllLegacy: () => [queryKeysDataExchange.base(), 'list', 'LEGACY'] as const,
  getAllSuppliers: (queryParams) =>
    [queryKeysDataExchange.base(), 'list', queryParams].filter(
      Boolean,
    ) as const,
  getCompanies: (initDataExchangeCompanies = true) =>
    [
      queryKeysDataExchange.base(),
      'companies',
      { initDataExchangeCompanies },
    ] as const,
  getCompany: (companyId: UUID) =>
    [queryKeysDataExchange.base(), 'company', companyId] as const,
  getCompanyAccounts: () =>
    [queryKeysDataExchange.base(), 'companyAccounts'] as const,
  getDataAsExcel: (queryParams: Partial<DataExchangeExcelDataType>) =>
    [queryKeysDataExchange.base(), 'excelData', queryParams] as const,
  getPartnerCompanies: (queryParams?: unknown) =>
    [queryKeysDataExchange.base(), 'company', queryParams].filter(
      Boolean,
    ) as const,
  getPartnerCompany: (companyId: UUID) =>
    [queryKeysDataExchange.base(), 'company', companyId] as const,
} as const;
